import { graphql } from "lib/generated/app-service-gql";
import { RevealedContactSuppressionsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation, useGraphQlQuery } from "../useGraphQlClient";

const revealedContactSuppressions = graphql(`
  query revealedContactSuppressions {
    revealedContactSuppressions {
      suppressed {
        revealedContactId
        source
        cognismContactId
        contactUrn
        email
        sources
        firstSeenAt
        reason
      }
    }
  }
`);

/**
 * Opt-out status of this company's revealed contacts, from either provider.
 *
 * The report also counts how many contacts were checked; this asks only for the
 * matches, which is all the summary needs.
 */
export function useRevealedContactSuppressions() {
  return useGraphQlQuery(["revealedContactSuppressions"], revealedContactSuppressions, []);
}

export type RevealedContactSuppressionReport =
  RevealedContactSuppressionsQuery["revealedContactSuppressions"];

const exportContactSuppressions = graphql(`
  mutation exportContactSuppressions($exportFormat: ExportFormatArgs!) {
    exportContactSuppressions(ExportFormat: $exportFormat) {
      id
    }
  }
`);

// Returns an export id; pass it to useFileExport for the download. One file
// covering the company's revealed contacts from both providers.
export function useExportContactSuppressions() {
  const { data, ...rest } = useGraphQlMutation(exportContactSuppressions);
  return { data: data?.exportContactSuppressions, ...rest };
}
